export default function decodeBase64(value: string, defaultValue: string = ''): string {
  try {
    return atob(value) || defaultValue;
  } catch (_e) {
    return defaultValue;
  }
}
